import { useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLeadByIdQuery } from 'api';
import { AssignmentRoleMapping } from 'models/Lead';
import { useAdminUsersMapping } from 'hooks/useAdminMapping';

export const useDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: leadDetails = {}, isLoading } = useLeadByIdQuery({ id });
  const { adminUsersMapping } = useAdminUsersMapping();
  const [openDetailsEditModal, setOpenDetailsEditModal] = useState(false);
  const [openAssignmentEditModal, setOpenAssignmentEditModal] = useState(false);
  const { administratorId, salesManagerId, salesManagerAssistantId, purchaseManagerAssistantId, purchaseManagerId } =
    leadDetails;

  const onUpdateDetailsClick = useCallback(() => {
    setOpenDetailsEditModal(true);
  }, []);

  const onCloseDetailsEditModal = useCallback(() => {
    setOpenDetailsEditModal(false);
  }, []);

  const onUpdateAssignmentClick = useCallback(() => {
    setOpenAssignmentEditModal(true);
  }, []);

  const onCloseAssignmentEditModal = useCallback(() => {
    setOpenAssignmentEditModal(false);
  }, []);

  const assignmentData = useMemo(() => {
    return [
      { role: AssignmentRoleMapping.administrator, data: adminUsersMapping[administratorId] || {} },
      { role: AssignmentRoleMapping.salesManager, data: adminUsersMapping[salesManagerId] || {} },
      { role: AssignmentRoleMapping.salesManagerAssistant, data: adminUsersMapping[salesManagerAssistantId] || {} },
      { role: AssignmentRoleMapping.purchaseManager, data: adminUsersMapping[purchaseManagerId] || {} },
      {
        role: AssignmentRoleMapping.purchaseManagerAssistant,
        data: adminUsersMapping[purchaseManagerAssistantId] || {},
      },
    ];
  }, [
    adminUsersMapping,
    purchaseManagerId,
    purchaseManagerAssistantId,
    salesManagerId,
    salesManagerAssistantId,
    administratorId,
  ]);

  return {
    leadDetails,
    onUpdateDetailsClick,
    onUpdateAssignmentClick,
    openDetailsEditModal,
    openAssignmentEditModal,
    onCloseDetailsEditModal,
    onCloseAssignmentEditModal,
    assignmentData,
    adminUsersMapping,
    isLoading,
    isFinalStatus: leadDetails.isFinalStatus,
  };
};
